<form class="modal-body wrapper-modal position-relative create-vehicle-application-dialog" [formGroup]="form"
  (ngSubmit)="onSubmit()">
  <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="close()"></i>

  <p class="title text-center text-break">{{ mode === 'create' ? 'Crear postulación' : 'Editar postulación' }}</p>

  <div class="create-vehicle-application-dialog__content row mx-0">
    <p class="col-12 my-3 text-bold">
      Placa
    </p>
    <mat-form-field appearance="outline" class="col-12">
      <mat-label>Placa<span class="asterisk">*</span></mat-label>
      <input matInput appLicensePlate formControlName="licensePlate" maxlength="8" placeholder="Ej: ABC123">
      <mat-error *ngIf="form.get('licensePlate').errors?.pattern">
        El formato de la placa no es válido
      </mat-error>
      <mat-error *ngIf="form.get('licensePlate').errors?.required">
        {{ utils.giveMessageError('MANDATORY_FIELD') }}
      </mat-error>
    </mat-form-field>

    <p class="col-12 my-3 text-bold">
      Vehículo
    </p>
    <app-type-vehicle [inputFormControl]="form.get('vehicleTypeName')" [options]="{
      showAutocomplete: true,
      initialValue: form.get('vehicleTypeName')?.value?.name
    }" class="col-12 col-md-6" [validate]="formValidate"></app-type-vehicle>
    <app-vehicle-body-work-type [inputFormControl]="form.get('bodyWorkTypeName')" [options]="{
      title: 'Tipo de carrocería',
      initialVehicleTypeId: form.get('vehicleTypeName')?.value?.id,
      initialValue: form.get('bodyWorkTypeName')?.value?.name
    }" class="col-12 col-md-6" *ngIf="form.get('vehicleTypeName')?.value?.name" [validate]="formValidate">
    </app-vehicle-body-work-type>

    <p class="col-12 my-3 text-bold">
      Conductor
    </p>
    <mat-form-field appearance="outline" class="col-12 col-md-6">
      <mat-label>Documento del conductor<span class="asterisk">*</span></mat-label>
      <input matInput onlyNumbersInt formControlName="applicantId" maxlength="40" placeholder="Ej: 123456789">
      <mat-error *ngIf="form.get('applicantId').errors?.required">
        {{ utils.giveMessageError('MANDATORY_FIELD') }}
      </mat-error>
      <mat-error *ngIf="form.get('applicantId').errors?.minlength">
        {{ utils.giveMessageError('MIN_LENGTH_NOT_REACHED', 'documento del conductor', 7) }}
      </mat-error>
      <mat-error *ngIf="form.get('applicantId').errors?.maxlength">
        {{ utils.giveMessageError('MAX_LENGTH_EXCEED', 'documento del conductor', 15) }}
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-12 col-md-6">
      <mat-label>Celular<span class="asterisk">*</span></mat-label>
      <input matInput onlyNumbersInt formControlName="phone" maxlength="20" placeholder="Ej: 3001234567">
      <mat-error *ngIf="form.get('phone').errors?.required">
        {{ utils.giveMessageError('MANDATORY_FIELD') }}
      </mat-error>
      <mat-error *ngIf="form.get('phone').errors?.pattern">
        El formato del número de celular no es válido
      </mat-error>
      <mat-error *ngIf="form.get('phone').errors?.maxlength">
        {{ utils.giveMessageError('MAX_LENGTH_EXCEED', 'número de celular', 12) }}
      </mat-error>
      <mat-error *ngIf="form.get('phone').errors?.minlength">
        {{ utils.giveMessageError('MIN_LENGTH_NOT_REACHED', 'número de celular', 7) }}
      </mat-error>
    </mat-form-field>

    <p class="col-12 my-3 text-bold">
      Adicionales
    </p>
    <mat-form-field appearance="outline" class="col-12 col-md-6">
      <mat-label>Capacidad de carga (kg)<span class="asterisk">*</span></mat-label>
      <input matInput type="number" formControlName="loadCapacity" placeholder="Ej: 12000">
      <mat-error *ngIf="form.get('loadCapacity').errors?.required">
        {{ utils.giveMessageError('MANDATORY_FIELD') }}
      </mat-error>
      <mat-error *ngIf="form.get('loadCapacity').errors?.min">
        {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED', 'capacidad de carga', 1) }}
      </mat-error>
      <mat-error *ngIf="form.get('loadCapacity').errors?.max">
        {{ utils.giveMessageError('MAX_VALUE_EXCEED', 'capacidad de carga', maxLoadCapacity) }}
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-12 col-md-6">
      <mat-label>Oferta<span class="asterisk">*</span></mat-label>
      <input matInput type="text" currencyMask placeholder="$000.000" formControlName="offer">
      <mat-error *ngIf="form.get('offer').errors?.required">
        {{ utils.giveMessageError('MANDATORY_FIELD') }}
      </mat-error>
      <mat-error *ngIf="form.get('offer').errors?.min">
        {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED', 'oferta', 1) }}
      </mat-error>
      <mat-error *ngIf="form.get('offer').errors?.max">
        {{ utils.giveMessageError('MAX_VALUE_EXCEED', 'oferta', maxOffer) }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="button-container mt-3 justify-content-end">
    <button mat-raised-button class="primary-secondary button-width-auto mx-1" color="primary" type="button"
      (click)="close()">
      Cancelar
    </button>
    <button mat-raised-button class="button-width-auto bg-color-primary mx-1" color="primary" type="submit">
      {{ mode === 'create' ? 'Crear' : 'Editar' }}
    </button>
  </div>
</form>